import { HttpBackend, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { IExchangeCodeRequest, ITokensRestApiDto } from '@lite-workspace/dto-auth';
import { AuthState } from './auth';

@Injectable({ providedIn: 'root' })
export class LoginCodeService {
  // No session exists yet, so the exchange goes around the interceptors: a stale bearer from an
  // earlier login must not ride along, and a failed exchange must not start a token refresh.
  private readonly http = new HttpClient(inject(HttpBackend));

  /** Redeems the one-time login code for the token pair; null when the code is refused or the call fails. */
  async exchange(code: string): Promise<AuthState | null> {
    try {
      const body: IExchangeCodeRequest = { code };
      const tokens = await firstValueFrom(this.http.post<ITokensRestApiDto>('/api/auth/exchange-code', body));
      return tokens?.accessToken ? { accessToken: tokens.accessToken, refreshToken: tokens.refreshToken } : null;
    } catch (error: unknown) {
      // A systemic refusal (ingress without the route, a dead store, 429) must stay visible, yet the
      // code never reaches the log: only the HTTP status or the error class does.
      const reason: string | number = error instanceof HttpErrorResponse ? error.status : ((error as Error)?.name ?? 'unknown');
      console.warn('[session] login code exchange refused', reason);

      return null;
    }
  }
}
